import { useRef } from "react";
import { useElementSize } from "../../../../utils/useElementSize";

interface IProps {
    scaleCssVariableName: `--site-preview-scale-${string}`;
}

const calculateScale = (wrapperWidth?: number, bodyWidth?: number) => {
    if (!wrapperWidth || !bodyWidth) return 0;
    bodyWidth = bodyWidth > 1400 ? 1400 : bodyWidth; // 1600 also needs to be set in GeneratorSitePreview.module
    let scale = wrapperWidth / bodyWidth;
    if (scale > 1) scale = 1;
    return scale.toFixed(3);
};

export function GeneratorSitePreviewScaleSetter(props: IProps) {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const wrapperSize = useElementSize(wrapperRef, 300);
    const bodySize = useElementSize(document.body, 300);

    const scale = calculateScale(wrapperSize?.width, bodySize?.width);

    document.documentElement.style.setProperty(props.scaleCssVariableName, scale.toString());

    return <div ref={wrapperRef}></div>;
}
